import { AxiosResponse } from "axios";
import { Label } from "../types/label";
import { aplClient } from "./apiClient";

const getActiveLabels = (): Promise<AxiosResponse<Label[], any>> => aplClient().get("labels/active");

export { getActiveLabels };
